import type { AuthUser } from '@gyym/sdk'
import type { GetServerSidePropsContext } from 'next'

import { createServerGyymApiClient } from '#utils/createServerGyymApiClient'
import { gyymPrefetch } from '#utils/gyymPrefetch'
import { ServerCachedContext } from '#utils/types'

export const withGyymAuth = <P extends { initialUser: AuthUser }>() => {
  return async (
    ctx: GetServerSidePropsContext,
    { composedProps, client: cachedClient }: ServerCachedContext<P> = {},
  ) => {
    // Create new client if not cached
    const client = cachedClient ?? createServerGyymApiClient({ ctx })

    // Fetch auth user
    const [key, authUser] = composedProps?.initialUser
      ? [client.auth.user.get.getKey(), composedProps?.initialUser]
      : await gyymPrefetch(client.auth.user.get)

    return {
      props: {
        swr: {
          fallback: {
            [key]: authUser,
          },
        },
        initialUser: authUser,
      },
    }
  }
}
